import { Typography } from "@mui/material";
import React, { useState, useEffect } from 'react';
import AlternateEmailIcon from '@mui/icons-material/AlternateEmail';
import clienteAxios from '../../helpers/clienteAxios';
import clienteAxiosAux from '../../helpers/clienteAxiosAux';

import "./reclamos.scss"


const ReclamoMailRespuesta = () => {
    const [cargando, setCargando] = useState(false);
    const [mensaje, setMensaje] = useState("");

    const descargarArchivo = () => {
        setCargando(true)
        const search = window.location.search;
        const params = new URLSearchParams(search);
        const extencion = params.get("extencion");
        const mime = params.get("mime");
        const nombreArchivo = params.get("nombreArchivo");
        const user = params.get("user");
        const signature = params.get("signature");

        const formData = {
            params: {
                extencion: extencion,
                mime: mime,
                nombreArchivo: nombreArchivo,
                user: user,
                signature: signature,


            },
            responseType: 'blob',
        };

        clienteAxiosAux.get(
            `/sucursalVirtual/obtener-archivo`, formData)
            .then((response) => {
                setCargando(false);
                if (response.data) {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'respuesta.pdf');
                    document.body.appendChild(link);
                    link.click();
                    setMensaje("Archivo descargado");

                } else {
                    setMensaje("Error al descargar el archivo");
                }
            })
            .catch((error) => {
                console.error(error);
                setMensaje("Error al descargar el archivo");
            })

    }

    useEffect(() => {
        descargarArchivo();
    }, [])

    return (
        <div container alignItems='center' justify='center' className="background">
            <div container spacing={2} className="root">
                <div item xs={false} sm={1}></div>
                <div item xs={12} sm={10} spacing={3}>
                    <div>
                        <Typography variant="h2" style={{ color: "#fddc02", fontWeight: "bold", textAlign:"center" }} >
                            {mensaje}
                        </Typography>


                        <Typography variant="h4" style={{ color: "#fff", textAlign:"center" }}>
                            El proceso ha finalizado.
                        </Typography>


                        <Typography style={{textAlign:"center"}}>
                            <AlternateEmailIcon style={{ fontSize: '15em', color: "#fff" }} />


                        </Typography>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default ReclamoMailRespuesta;

